import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const CustomButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selectedFilter',
})<{ selectedFilter: boolean }>(({ theme, selectedFilter }) => ({
  textTransform: 'none',
  width: '50%',
  height: 40,
  borderRadius: 4,
  '&.MuiButton-root': {
    ...(selectedFilter && {
      backgroundColor: theme.palette.primary.main,
    }),

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: theme.palette.grey[700],
    },
  },
  '&.MuiButton-outlined': {
    borderColor: selectedFilter
      ? theme.palette.primary.main
      : theme.palette.grey[400],
    color: selectedFilter ? theme.palette.grey[700] : theme.palette.grey[400],
  },
}));
export default CustomButton;

// Source code: https://codesandbox.io/s/5nepgp?file=/demo.tsx:0-1807
